import { useState, useEffect } from "react";
import { Button } from "../ui/button";

export const ShareNow = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const handleShare = async () => {
    if (navigator.share) {
      // Mobile native share
      try {
        await navigator.share({
          title: "Join me on Igbanwo 🌱",
          text: "Start sharing your harvest and discover fresh, local produce!",
          url: window.location.origin,
        });
      } catch (err) {
        console.error("Error sharing:", err);
      }
    } else {
      // Desktop fallback → copy link
      try {
        await navigator.clipboard.writeText(window.location.origin);
        setShowModal(true);

        // Hide modal after 2 seconds
        setTimeout(() => setShowModal(false), 2000);
      } catch (err) {
        console.error("Clipboard copy failed:", err);
      }
    }
  };

  return (
    <section
      className={`bg-gradient-to-br from-igbanwo-mint/90 to-igbanwo-mint rounded-2xl p-10 text-white text-center transition-all duration-1000 delay-400 transform ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
      }`}
    >
      <h2 className="text-3xl font-bold mb-4">Start Sharing Your Harvest Today</h2>
      <p className="max-w-2xl mx-auto mb-8 text-white/90">
        Join our growing community of home gardeners and food enthusiasts. Share your bounty and discover fresh, local produce.
      </p>
      <Button
        onClick={handleShare}
        className="bg-white text-igbanwo-mint hover:bg-white/90"
      >
        Share to Friends
      </Button>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50">
          <div className="bg-white text-black px-6 py-4 rounded-xl shadow-xl">
            ✅ Link copied to clipboard!
          </div>
        </div>
      )}
    </section>
  );
};
